import { render } from "./BgOverlayTexture.vue?vue&type=template&id=7a26cd3a"
import script from "./BgOverlayTexture.vue?vue&type=script&lang=js"
export * from "./BgOverlayTexture.vue?vue&type=script&lang=js"

import "./BgOverlayTexture.vue?vue&type=style&index=0&id=7a26cd3a&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__